<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { makeGeoJson } from '~/utils/riverUtils'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const mapContainer = ref(null)
const { sourceGeojson, clusterGeojson, zoomLevel } = usePointCluster()
const { initMap, getRiverRiskData, setRiverRisk, updatePointIcon, loadedMap, tmpZoomLevel, tmpMapCenter } = useRiverMap()
const unClusteredGeojson = ref(null)
const mapZoom = useState('mapZoom', () => 4)
const mapCenter = useState('mapCenter', () => [137.0, 38.5])
const updateTime = ref('')

watch(() => clusterGeojson.value, (newValue) => {
  if (!loadedMap.value) return
  const map = loadedMap.value
  const source = map.getSource('obsCamClusteredPoints')
  source.setData(newValue)
})

watch(() => unClusteredGeojson.value, (newValue) => {
  if (!loadedMap.value) return
  const map = loadedMap.value
  const source = map.getSource('obsCamUnClusteredPoints')
  source.setData(newValue)
})

watch(() => tmpZoomLevel.value, (newValue) => {
  zoomLevel.value = newValue
  mapZoom.value = newValue
})

watch(() => tmpMapCenter.value, (newValue) => {
  mapCenter.value = newValue
})

onMounted(async () => {
  const [_, riskData] = await Promise.all([
    initMap(mapContainer.value, mapZoom.value, mapCenter.value),
    getRiverRiskData()
  ])
  setRiverRisk(riskData)
  const [csv, waterLevel] = await Promise.all([
    $fetch('/api/river/csv'),
    $fetch('/api/river/waterlevel')
  ])
  const { clusteredGeoJson, unclusteredGeoJson } = makeGeoJson(csv, waterLevel.list)
  sourceGeojson.value = clusteredGeoJson
  unClusteredGeojson.value = unclusteredGeoJson
  updateTime.value = waterLevel.update_time
  updatePointIcon('no-select')
})
</script>

<template>
  <section class="zoomMap">
    <CommonPageTitle
      title="河川水位情報"
      :text="updateTime ? `${dayjs.unix(updateTime).tz('Asia/Tokyo').format('H:mm')}更新` : '--:--更新'"
    />
    <div
      ref="mapContainer"
      class="map-container"
    >
      <RiverLegend />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.zoomMap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .map-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    aspect-ratio: 4 / 3;
  }
}
</style>
